import { HighlightItem, OrderItemWithCustomerOrderId } from 'store/favourite/types';

const toSearchResultProductFromOrders = (p: OrderItemWithCustomerOrderId, locale: string) => {
  const result = {
    id: String(p.orderItemId),
    images: p.previewEditorMedium || [],
    categoryId: p.categoryId,
    deepLink: '',
    name: p.name,
    productId: p.productId,
    productTypeId: p.productTypeId,
    subTitle: '',
    url: 'no-link',
    productTier: p.productTypeName,
    sku: '',
    favourited: false,
    customerOrderId: p.customerOrderId,
    encOrderItemId: p.encOrderItemId,
    encDesignId: p.encDesignId,
    orderItemId: p.orderItemId,
    purchaseDate: new Date(p.timestamp * 1000).toLocaleDateString(locale, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }),
  } as HighlightItem;

  return result;
};

export default toSearchResultProductFromOrders;
